import { CrudAbstractModel } from "../crud-abstract/crud-abstract.model";
import { SurchargeTranslation } from "./surcharge-translation.model";
import { SurchargeTypeUpdater } from "./surcharge-type-updater/surcharge-type-updater.model";

export class SurchargeType extends CrudAbstractModel {
  constructor(
    public id: number,
    private name: string,
    private ref: string,
    private internalDescription: string,
    private mandatory: boolean,
    private uber: boolean,
    private noMargin: boolean,
    private internalComment: string,
    private externalDescription: string,
    private ltlSurchargeType: string,
    private active: boolean = null,
    private spot: boolean = null,
    private applyInPtlQuotes: boolean = null,
    private spotData: SurchargeTypeUpdater | null = null,
    private translations: SurchargeTranslation[] = [],
    private incoterms: string[] = [],
    private selected: boolean = null,
    private deleted: boolean = null,
    private failedRestrictions: string = null,
  ) {
    super(id);
  }

  public getSelected(): boolean {
    return this.selected;
  }

  public getDeleted(): boolean {
    return this.deleted;
  }

  public getWarningMessage(): string {
    return (this.failedRestrictions ?? "").replace(
      /{{rs:([0-9]+):([0-9]+)}}/gm,
      "<a href='/rate/fcl/contract/$1?surcharge=$2' target='_blank'><i class='pi pi-external-link'></i></a>",
    );
  }

  public getId(): number {
    return this.id;
  }

  public getName(): string {
    return this.name;
  }

  // No locale (user without a language) or a translation saved without a
  // name falls back to the main name.
  public getNameForLocale(locale: string): string {
    if (!locale) {
      return this.name;
    }

    for (const translation of this.translations) {
      if (translation.locale === locale && translation.name) {
        return translation.name;
      }
    }

    return this.name;
  }

  public getRef(): string {
    return this.ref;
  }

  public getActive(): boolean {
    return this.active;
  }

  public getInternalDescription(): string {
    return this.internalDescription;
  }

  public getMandatory(): boolean {
    return this.mandatory;
  }

  public getUber(): boolean {
    return this.uber;
  }

  public getNoMargin(): boolean {
    return this.noMargin;
  }

  public getLtlSurchargeType(): string {
    return this.ltlSurchargeType;
  }

  public getExternalDescription(): string {
    return this.externalDescription;
  }

  public getInternalComment(): string {
    return this.internalComment;
  }

  public getTranslations(): SurchargeTranslation[] {
    return this.translations;
  }

  public getIncoterms(): string[] {
    return this.incoterms;
  }

  public getSpot(): boolean {
    return this.spot;
  }

  public getApplyInPtlQuotes(): boolean {
    return this.applyInPtlQuotes;
  }

  public setSpot(spot: boolean): void {
    this.spot = spot;
  }

  public getSpotData(): SurchargeTypeUpdater | null {
    return this.spotData;
  }

  public setSpotData(spotData: SurchargeTypeUpdater | null): void {
    this.spotData = spotData;
  }

  public getRequestParams() {
    return {
      name: this.getName(),
      ref: this.getRef(),
      internalDescription: this.getInternalDescription(),
      mandatory: this.getMandatory(),
      uber: this.getUber(),
      noMargin: this.getNoMargin(),
      internalComment: this.getInternalComment(),
      externalDescription: this.getExternalDescription(),
      ltlSurchargeType: this.getLtlSurchargeType(),
      translations: this.getTranslations(),
      spot: this.getSpot(),
      applyInPtlQuotes: this.getApplyInPtlQuotes(),
      spotData: this.getSpotData()
        ? this.getSpotData().getRequestParams()
        : null,
      incoterms: this.getIncoterms(),
    };
  }
}
